import { PayloadAction } from '@reduxjs/toolkit';

import { FormatSelector, FormatsState } from 'editor/src/store/editorModules/formats/types';

const setFormatsDataReducer = (state: FormatsState, action: PayloadAction<FormatSelector[]>) => {
  state.selectors = action.payload;
};

export default setFormatsDataReducer;
